import React, {FC} from "react";
import {ToastProps} from "./Toast.types";
import styles from "./Toast.module.scss";
import {Toaster} from 'react-hot-toast';
import {CICheckCircle, CIExclamationCircle, CITriangleExclamation, CITimes} from "@dua.design/icons";
import {Button, Typography} from "../index";

export const ToastWrapper: FC<ToastProps> = ({message, type, onDismiss}: ToastProps) => {
    return <div className={styles.toastWrapper}>
        <div className={styles.iconContainer}>
            {type === "success" && <CICheckCircle type={'filled'} fill={'#34C759'} size={24}/>}
            {type === "error" && <CITriangleExclamation type={'filled'} fill={'#EF3054'} size={24}/>}
            {type === "warning" && <CIExclamationCircle type={'filled'} fill={'#FFA124'} size={24}/>}
        </div>
        <div className={styles.content}>

            <div>
                <Typography variant={'h3'} weight={'medium'} token={200}>
                    {type === "success" && "Success"}
                    {type === "error" && "Error"}
                    {type === "warning" && "Warning"}
                </Typography>
                <Typography variant={'p'} token={100} weight={'normal'}>{message}</Typography>
            </div>
        </div>
        <div className={styles.divider}/>
        <Button color={'link'} className={styles.dismissButton} variant={'outlined'} size={'small'}
                startIcon={<CITimes color={"#8F9193"} onClick={onDismiss}/>}/>
    </div>
};


export const Toast = () => {
    return <div data-testid="Toast"><Toaster
        toastOptions={{className: '', style: {all: 'unset', pointerEvents: 'auto'}}}/></div>
}
